import { FC, memo } from 'react'

import { ShieldUser, World } from 'components/icons'
import { Tooltip, Box } from '@chakra-ui/react'

type Props = {
  visibility?: string
  labels?: any
}

const VisibilityIcon: FC<Props> = ({ visibility, labels }) => {
  if (!visibility) return <></>

  const label = labels ? labels[visibility] : ''

  if (visibility === 'PRIVATE') {
    return (
      <Tooltip label={label}>
        <Box>
          <ShieldUser color="dark" />
        </Box>
      </Tooltip>
    )
  }

  if (visibility === 'PUBLIC') {
    return (
      <Tooltip label={label}>
        <Box>
          <World color="dark" />
        </Box>
      </Tooltip>
    )
  }

  return <></>
}

export default memo(VisibilityIcon)
